module.exports = __webpack_public_path__ + "img/apps_black.8b94c50b.svg";